import AuthenticationRoutes from '../../Features/Patient/Routes/Routes';

const PublicRoute = [...AuthenticationRoutes];

export default PublicRoute;
